export default "__VITE_ASSET__00713679__"